import { useEffect, useState } from 'react';

type UseDebouncedMemoType = <T>(
  factory: () => T,
  dependencies: React.DependencyList,
  delay?: number
) => T | null;

const useDebouncedMemo: UseDebouncedMemoType = <T>(
  factory: () => T,
  dependencies: React.DependencyList,
  delay = 500
) => {
  const [debouncedValue, setDebouncedValue] = useState<T | null>(null);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(factory()), delay);

    return () => clearTimeout(handler);
  }, dependencies);

  return debouncedValue;
};

export default useDebouncedMemo;
